import { SVGProps } from 'react';

export const OrdersIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.67963 13C2.67963 7.30018 7.30022 2.67958 13 2.67958C18.6998 2.67958 23.3204 7.30018 23.3204 13C23.3204 18.6997 18.6998 23.3203 13 23.3203C7.30022 23.3203 2.67963 18.6997 2.67963 13ZM13 0.949954C6.34496 0.949954 0.95 6.34492 0.95 13C0.95 19.655 6.34496 25.05 13 25.05C19.655 25.05 25.05 19.655 25.05 13C25.05 6.34492 19.655 0.949954 13 0.949954Z"
        fill="#282828"
        stroke="#282828"
        strokeWidth="0.1"
      />
      <path
        d="M8.31202 13.9696L8.31201 13.9696C8.04836 13.7154 8.02743 13.2784 8.26706 12.9966L8.26707 12.9966C8.50362 12.7183 8.90353 12.6979 9.1636 12.9487L9.1636 12.9487L11.5257 15.2263L11.5951 15.2932L11.6645 15.2263L17.8363 9.27522C18.0964 9.02445 18.4963 9.04488 18.7329 9.3231C18.9726 9.60494 18.9516 10.0419 18.688 10.2961L12.0209 16.7247C11.7786 16.9584 11.4117 16.9584 11.1693 16.7247L8.31202 13.9696Z"
        fill="#282828"
        stroke="#282828"
        strokeWidth="0.2"
      />
    </svg>
  );
};
